import Tracker, { TrackerEcommerceEventType } from '@xFrame4/common/Tracker';
import KlaviyoHelper from '@helpers/KlaviyoHelper';

export class AppTracker extends Tracker
{
    static currency = 'RON';
    
    protected static createInstance(): AppTracker
    {
        return new AppTracker();
    }

    protected async init()
    {
        this.trackWithGoogle = true;
        this.trackWithFacebook = true;
        this.trackWithFacebookConversionsApi = true;
        //this.handleScriptLoading = false;
        this.lazyLoadScripts = this.checkLazyLoadingForPage()

        super.init();
    }

    /**
     * Check if lazy loading the tracking scripts is enabled on the page.
     */
    private checkLazyLoadingForPage(): boolean
    {
        let notEnabledUrls = [
            '/cos-de-cumparaturi',
            '/detalii-facturare-livrare',
            '/metoda-de-plata',
            '/comanda-inregistrata-cu-succes',
            '/comanda-si-plata-inregistrata',
            '/platesc',
            '/plata-cu-tbi',
            '/comanda-nefinalizata-cu-tranzactie-esuata',
            'cancelorder.php',
            '/schimbare-metoda-de-plata',
            '/rezervati-in-magazin',
            '/rezervare-reusita'
        ];

        let url = window.location.pathname;
        for (let i = 0; i < notEnabledUrls.length; i++)
        {
            if (url.indexOf(notEnabledUrls[i]) !== -1)
            {
                return false;
            }
        }

        return true;
    }
}

export default AppTracker;